import { useCallback, memo } from 'react'
import { TechAnalysis } from '../Widgets/types'
import { yieldToMain } from '@/root/utils/yield-to-main'
import { TabUI } from '@/revamp/reusable-components/tab-ui'

const Timeline = ({
  technical_analysis,
  selectedTab,
  setSelectedTab,
}: {
  technical_analysis: TechAnalysis[]
  selectedTab: number
  setSelectedTab: (index: number) => void
}) => {
  const handleTabClick = useCallback(
    (index: number) => async () => {
      await yieldToMain()
      setSelectedTab(index)
    },
    [setSelectedTab],
  )

  return (
    <div className="no-scrollbar mb-6 flex w-full gap-2 overflow-x-scroll">
      {technical_analysis.map(({ interval }, index) => {
        if (!interval) return null
        return (
          <TabUI
            key={`tab-${interval}-${index}`}
            isActive={index === selectedTab}
            onClick={handleTabClick(index)}
          >
            {interval}
          </TabUI>
        )
      })}
    </div>
  )
}

Timeline.displayName = 'Timeline'
export default memo(Timeline)
